import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DialogoVistaPreviaComponent } from './dialogo-vista-previa/dialogo-vista-previa.component';
import { DialogoAccionComponent } from './dialogo-accion/dialogo-accion.component';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DialogoFormularioComponent } from './dialogo-formulario/dialogo-formulario.component';
import { FormularioModule } from '../formulario/formulario.module';

@NgModule({
  declarations: [DialogoVistaPreviaComponent, DialogoAccionComponent, DialogoFormularioComponent],
  imports: [
    CommonModule,
    FormularioModule,

    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule,
  ],
})
export class DialogosModule {}
